/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */
import { PartyAddressDetail } from './party-address-detail.model';


export class Party {
    personId?: string;
    firstName?: string; // ecf001
    name?: string; // ecf001
    address?: PartyAddressDetail; // ecf001
    phoneNumber?: string; // ecf001
    mobileNumber?: string; // ecf001
    email?: string; // ecf001
    contactByEmail?: boolean; // ecf001
    roles?: string[]; // ecf001
    isProfessional?: boolean;


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): Party {
        if (!data) { return instance; }
        if (data.personId != null) {instance.personId = data.personId; }
        if (data.firstName != null) {instance.firstName = data.firstName; }
        if (data.name != null) {instance.name = data.name; }
        if (data.address != null) {instance.address = new PartyAddressDetail().fromJSON(data.address); } // i8
        if (data.phoneNumber != null) {instance.phoneNumber = data.phoneNumber; }
        if (data.mobileNumber != null) {instance.mobileNumber = data.mobileNumber; }
        if (data.email != null) {instance.email = data.email; }
        if (data.contactByEmail != null) {instance.contactByEmail = data.contactByEmail; }
        if (data.roles != null) {instance.roles = data.roles; }
        if (data.isProfessional != null) {instance.isProfessional = data.isProfessional; }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return Party.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: Party) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return Party.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: Party): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
